import './global.js'
import React, { Component,useEffect } from 'react';
import Parse from 'parse';
import $ from "jquery";
import ReactGA from 'react-ga';
import { StickyContainer, Sticky } from 'react-sticky';
import './App.css';
import { commonLogoutFunction, commonVariable } from './common';
import SearchPage from "./SearchPage.jsx";
import CommonPopup from './CommonPopup.jsx';
//import Popup from "./Popup.jsx";

  function time_ago(time) {

    switch (typeof time) {
      case 'number':
        break;
      case 'string':
        time = +new Date(time);
        break;
      case 'object':
        if (time.constructor === Date) time = time.getTime();
        break;
      default:
        time = +new Date();
    }
    var time_formats = [
      [60, 's', 1], // 60
      [120, '1m', '1 minute from now'], // 60*2
      [3600, 'm', 60], // 60*60, 60
      [7200, '1h', '1 hour from now'], // 60*60*2
      [86400, 'h', 3600], // 60*60*24, 60*60
      [172800, '1d', 'Tomorrow'], // 60*60*24*2
      [604800, 'd', 86400], // 60*60*24*7, 60*60*24
      [1209600, '1w', 'Next week'], // 60*60*24*7*4*2
      [2419200, 'w', 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, '1m', 'Next month'], // 60*60*24*7*4*2
      [29030400, 'm', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, '1y', 'Next year'], // 60*60*24*7*4*12*2
      [2903040000, 'y', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
      [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
   
    ];
    var seconds = (+new Date() - time) / 1000,
      token = '',
      list_choice = 1;

    if (seconds == 0) {
      return ''
    }
    if (seconds < 0) {
      seconds = Math.abs(seconds);
      //token = 'from now';
      token = '';
      list_choice = 2;
    }
    var i = 0,
      format;
    while (format = time_formats[i++])
      if (seconds < format[0]) {
        if (typeof format[2] == 'string')
          return format[list_choice];
        else
          return Math.floor(seconds / format[2]) + '' + format[1] + '' + token;
      }
    return time;
  }
class App extends Component {
  constructor(props) {
    super(props);

    // TODO don't forget to add your app and js ids
    
    Parse.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5", "sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw"); //PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
    Parse.serverURL = "https://parse.joelskitchen.com/parse";
    //Parse.serverURL = "https://parsetest.joelskitchen.com/parse";

    //console.log(Parse.serverURL);
    ReactGA.initialize('UA-60526992-2'); 
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // this.handlemenu = this.handlemenu.bind(this);
    this.selectSection = this.selectSection.bind(this);
    this.handleLogoutfunc = this.handleLogoutfunc.bind(this);
    this.searchHistory = this.searchHistory.bind(this);
    this.handleDeleteAccount = this.handleDeleteAccount.bind(this);
    

   //  useEffect(() => {
    var getUsername=localStorage.getItem('username');
    var getUseremail=localStorage.getItem('useremail');
    var ispicture_popup=localStorage.getItem('ispicture_popup');
    setTimeout(function () {
      if(ispicture_popup=='true')
      {
         //window.alert('Signed up! Account created! If you want, you can add a profile picture and other info later.');
         localStorage.setItem('ispicture_popup',false );
      }
    }, 1000); 

    let currentUser = Parse.User.current(); 
    let displayUsername='';
    if(currentUser)
    {
       displayUsername = currentUser.get("displayUsername");
    }
    
    this.usernameParam = displayUsername;
    
    this.state = {
            getUsername: getUsername,
            getUseremail:getUseremail,
            userImage: null,
            searchusers: [],
            searchloading:false,
            filterSearchTitle:'',
            searchSuggestedUserId:[],
            searchSuggestedPhoto:[],
            searchloading1:false,
            filterSearchTitle1:'',
            searchHistoryData:[],
           /* isPopupOpenCommon: false,
            loading_common: false,
            error_common: null,
            post_common_id:'',
            postDetailscomment_common: null,
            postDetails_common: null,
            loadingdata_common:false,
            showPopup:false*/
            isPopupOpen1: false,
            post_common_id1:''

        };
    this.queryForUserRecordData();
    this.searchSuggestion();
    this.searchSuggestionCloase();
    this.topAccounts();
    this.getSuggestedUserId();
    //this.handleSearchFilterChange();
    this.handleSearchFilterChange1();
    this.getSearchHistory();
    //localStorage.setItem('storestreamtabValue', '');
    

  } 

 

 
  getSearchHistory() {
      
      const currentUser = Parse.User.current();

      if(currentUser)
      {
         var searchquery = new Parse.Query('Searchhistory');
         searchquery.equalTo('user', currentUser);
         searchquery.descending("_created_at");
         var self = this;
         searchquery.find().then(function(result){
            if(result){
              self.setState({ searchHistoryData: result});
            }
          })
      }
  }
  getSuggestedUserId() { 
      var query = new Parse.Query('User');
      query.equalTo('isSuggested', 1);
      query.descending('_created_at');
      query.limit(10);
      const { filterSearchTitle,filterSearchTitle1  } = this.state;
      var self = this;
       query.find().then(function(result){
            if(result){
              let userSuggdataresult1 = [];
              if(result.length>0)
              {               
                   for (var i = 0; i < result.length; i++)
                   {
                     var user = result[i];
                     userSuggdataresult1[i]='_User$'+user.id;
                   } 
                    //loop
                    var queryphoto = new Parse.Query('Photo');
                    queryphoto.include("user");
                    queryphoto.limit(6);
                    let jointuser=userSuggdataresult1;//["_User$5CJeW8oA1k","_User$lT8FObMmNn"];
                   // queryphoto.containedIn('user', jointuser);
                    queryphoto.descending("createdAt");
                      if (filterSearchTitle) {
                        queryphoto.contains('caption', filterSearchTitle);
                      }
                      /*if (filterSearchTitle1) {
                        queryphoto.contains('caption', filterSearchTitle1);
                      }*/
                    queryphoto.find().then(function(photo){
                        self.setState({ searchSuggestedPhoto: photo,
                          searchloading1: true });
                    });

                    //loop
              }
              // self.setState({users: result});
            } else {
                //console.log("No user found");
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
        });
  }
 componentDidMount() {
   
    this.fetchSearchData();
    //this.createEntry();
   
  }
   fetchSearchData =async  () => {
    
    const { filterSearchTitle,filterSearchTitle1  } = this.state;
    var query = new Parse.Query('_User');
        query.limit(100);
        query.include("profilePictureSmall");
        query.include("displayName");  
        query.include("displayUsername");   
        query.descending("createdAt");
    if (filterSearchTitle) {
       query.contains('displayUsername', filterSearchTitle);
        //query.matches('displayUsername',  '/^'+filterSearchTitle+'/i');
       //query.containedIn('displayUsername', [filterSearchTitle]);
    }
    /*if (filterSearchTitle1) {
      query.contains('displayUsername', filterSearchTitle1);
    }*/
    try {
     const results = await query.find();
     this.setState({
          searchusers: results,
          searchloading: true
        });
      } catch (error) {
      console.error('Error while fetching books:', error);
    }
    /*await query.find()
      .then(results => { console.log(results);
        this.setState({
          searchusers: results,
          searchloading: true
        });
      })*/
      /*.catch(error => {
        console.error('Error fetching data:', error);
        this.setState({ searchloading: false });
      });*/
      this.getSuggestedUserId();
  };
  searchClear= (event) => {
      this.setState({ filterSearchTitle: '' }, () => {
      this.setState({ searchloading: true }, () => {
         this.fetchSearchData();
      });
    $("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn .search_inpt_inner").siblings(".search_rstl_mn").removeClass("active");
    $("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn button.close-btn").addClass("hide");
    });
      this.backAccounts();
    }
     handleSearchFilterChange1 = (event) => {

       const queryString = window.location.href;
       var challenge_id = queryString?queryString.split("/")[3]:''; 
       var  part = challenge_id?challenge_id.split('='):'';
       var searchtext=part?part[1]:'';
        var self = this;
    
       this.state.filterSearchTitle1=searchtext;
       this.state.filterSearchTitle='';
       this.setState({ searchloading: true }, () => {
        this.fetchSearchData();
        });

     }
    handleSearchFilterChange = (event) => {

     const queryString = window.location.href;
     var challenge_id = queryString?queryString.split("/")[4]:''; 
     var  part = challenge_id?challenge_id.split('='):'';
     var searchtext=part?part[1]:'';
     var searchval='';
     if(event && event.target.value)
     {
            searchval=event.target.value;
     }
    /* if(searchtext){
             searchval=searchtext;
     }*/
    // var searchval=searchval;
     //console.log(searchval+'searchval 111');
     localStorage.setItem('storestreamtabValue', event.target.value);
       
   this.setState({ filterSearchTitle: event.target.value,filterSearchTitle1: '' }, () => {
      this.setState({ searchloading: true }, () => {
        this.fetchSearchData();
      });
    });
   /*return ( <div className=''><SearchPage  postData={event.target.value}/>   
                </div>
        );*/

   
  };
  queryForUserRecordData() {
    var query = new Parse.Query('User');       
    query.equalTo("displayUsername", this.usernameParam);
    query.include("image");
    query.include("thumbnail");   
    var self = this;
    query.first().then(function(result){
        if(result){       
            self.setState({userImage: result.get("profilePictureSmall").url()});
        } else {

        }
    }, function(error){
            console.error("Error loading post Error: " + error);
    });
  }
  handleLogoutfunc = function(e){
    commonLogoutFunction();
  }
  handleDeleteAccount = function(e){
       $('#deleteaccountid').click();
  }
  deleteUserAccount= function(e){
    const currentUser = Parse.User.current();
        if(currentUser) {
          const currentUser_id = currentUser.id; 

          var photoquery = new Parse.Query('Photo');  
          photoquery.equalTo('user', currentUser);
          var self = this;
          photoquery.find().then(function(photo){
            if(photo) {
              for (const photos of photo) {
              //like
              var photoid=photos.id;
              var checklikequery = new Parse.Query('Like');  
               // checklikequery.equalTo('photo', "Photo$"+photos.id); console.log(photos.id+'photo.id');
                checklikequery.equalTo('fromUser',currentUser);
                checklikequery.find().then((object) => { 
                    if (object) {
                        for (const objects of object) {
                         
                             objects.destroy();
                           if(photoid!==objects.get('photo').id)
                            {  
                           var checklikequerycount = new Parse.Query('Like');  
                           checklikequerycount.equalTo('photo', "Photo$"+objects.get('photo').id);
                           checklikequerycount.doesNotExist("activity");
                           checklikequerycount.find().then((objectlike) => { 
                              if (objectlike.length) { console.log('objectlike');console.log(objectlike);
                                  var likeCountNew= objectlike.length?objectlike.length:0;
                                  var getPhotoquery = new Parse.Query('Photo');  
                                  getPhotoquery.equalTo('objectId', objects.get('photo').id);
                                  getPhotoquery.find().then(function(photo){
                                  if(photo)
                                  {
                                      let photo_ob=photo[0];
                                      //var commentcount= totalcomment?totalcomment:0;
                                        photo_ob.set("likeCountNew", likeCountNew); 
                                        photo_ob.save();
                                      }
                                  });

                              }
                           })
                         }
                        }
                    }
                  })
                  .then((deletedObject) => {


                  })
                  .catch((error) => {
                    console.error('Error deleting record:', error);
                  }); 
                  //like

                  //activity
                   var checkActivityquery = new Parse.Query('Activity');  
                   //checklikequery.equalTo('photo', "Photo$"+photos.id); 
                   checkActivityquery.equalTo('fromUser',currentUser);
                   checkActivityquery.find().then((object) => {
                    if (object) {
                          for (const objects of object) {
                            
                             objects.destroy();
                            if(photoid!==objects.get('photo').id)
                            {                              
                              var checkActivityquerynew = new Parse.Query('Activity');  
                              checkActivityquerynew.equalTo('photo', "Photo$"+objects.get('photo').id); 
                              checkActivityquerynew.find().then((object) => {
                              if (object) { 
                                  var commentcount= object.length?object.length:0;
                                  var getPhotoquery = new Parse.Query('Photo');  
                                  getPhotoquery.equalTo('objectId', objects.get('photo').id);
                                  getPhotoquery.find().then(function(photo){
                                  if(photo)
                                  {
                                      let photo_ob=photo[0];
                                      //var commentcount= totalcomment?totalcomment:0;
                                        photo_ob.set("commentcount", commentcount.toString()); 
                                        photo_ob.save();
                                      }
                                  });
                                 //like count check
                                   var checkActivityquerynewcount = new Parse.Query('Like');  
                                  //checkActivityquerynewcount.equalTo('photo', "Photo$"+objects.get('photo').id); 
                                  // console.log(object[0].id+'DDD');
                                   let newactivity_id=object[0].id;
                                   checkActivityquerynewcount.equalTo('activity', "Activity$"+newactivity_id);        
                                  checkActivityquerynewcount.find().then((objectdata) => {
                                  if (objectdata) {
                                      
                                         if(objectdata.length)
                                         {
                                          let likecount=objectdata.length?objectdata.length:0;
                                          var queryActivitydata = new Parse.Query('Activity');  
                                            queryActivitydata.equalTo('objectId', newactivity_id);
                                           
                                            queryActivitydata.find().then(function(activityUpdate){
                                                    if(activityUpdate)
                                                    {
                                                        let activity_ob=activityUpdate[0];
                                                         activity_ob.set("likeCount", likecount);
                                                         activity_ob.save();
                                                      }
                                                    })

                                         }
                                  }
                                })


                                 //like count check


                              }
                              })
                              //save
                              //save
                              var checkSavequery = new Parse.Query('Save');  
                              checkSavequery.equalTo('photo', "Photo$"+objects.get('photo').id);
                              checkSavequery.find().then((object) => {
                                  if (object) {
                                      for (const objects of object) {
                                            objects.destroy();
                                      }                       
                                  }
                                })
                                .then((deletedObject) => {

                                })
                                .catch((error) => {
                                  console.error('Error deleting record:', error);
                                }); 

                              //save

                              //save

                            }
                        }
                    }
                  })
                  .then((deletedObject) => {

                  })
                  .catch((error) => {
                    console.error('Error deleting record:', error);
                  }); 


                  //activity
                  //save
                  var checkSavequery = new Parse.Query('Save');  
                  checkSavequery.equalTo('photo', "Photo$"+photoid);
                  checkSavequery.find().then((object) => {
                      if (object) {
                          for (const objects of object) {
                                objects.destroy();
                          }                       
                      }
                    })
                    .then((deletedObject) => {

                    })
                    .catch((error) => {
                      console.error('Error deleting record:', error);
                    }); 

                  //save

                  //notification
                  var checkSavequery = new Parse.Query('Notification');  
                  checkSavequery.equalTo('photo', "Photo$"+photoid);
                  checkSavequery.find().then((object) => {
                      if (object) {
                          for (const objects of object) {
                                objects.destroy();
                          }                       
                      }
                    })
                    .then((deletedObject) => {

                    })
                    .catch((error) => {
                      console.error('Error deleting record:', error);
                    }); 

                  //notification

                 photos.destroy(); //delete photo
               }
            }
          })

//like 

              var checklikequery = new Parse.Query('Like');  
               // checklikequery.equalTo('photo', "Photo$"+photos.id); console.log(photos.id+'photo.id');
                checklikequery.equalTo('fromUser',currentUser);
                checklikequery.find().then((object) => { 
                    if (object) {
                        for (const objects of object) {
                         console.log('out ');
                         console.log(objects);
                             objects.destroy();
                           if(objects.get('photo').id)
                            {  
                           var checklikequerycount = new Parse.Query('Like');  
                           checklikequerycount.equalTo('photo', "Photo$"+objects.get('photo').id);
                           checklikequerycount.doesNotExist("activity");
                           checklikequerycount.find().then((objectlike) => { 
                              if (objectlike.length) { console.log('objectlike');console.log(objectlike);
                                  var likeCountNew= objectlike.length?objectlike.length:0;
                                  var getPhotoquery = new Parse.Query('Photo');  
                                  getPhotoquery.equalTo('objectId', objects.get('photo').id);
                                  getPhotoquery.find().then(function(photo){
                                  if(photo)
                                  {
                                    console.log(likeCountNew);
                                      let photo_ob=photo[0];
                                      //var commentcount= totalcomment?totalcomment:0;
                                        photo_ob.set("likeCountNew", likeCountNew); 
                                        photo_ob.save();
                                      }
                                  });

                              }
                           })

                           //new
                             var checkActivityquerynew = new Parse.Query('Activity');  
                              checkActivityquerynew.equalTo('photo', "Photo$"+objects.get('photo').id); 
                              checkActivityquerynew.find().then((object) => {
                              if (object) { 
                                  /*var commentcount= object.length?object.length:0;
                                  var getPhotoquery = new Parse.Query('Photo');  
                                  getPhotoquery.equalTo('objectId', objects.get('photo').id);
                                  getPhotoquery.find().then(function(photo){
                                  if(photo)
                                  {
                                      let photo_ob=photo[0];
                                     
                                        photo_ob.set("commentcount", commentcount.toString()); 
                                        photo_ob.save();
                                      }
                                  });*/
                                 //like count check
                                   var checkActivityquerynewcount = new Parse.Query('Like');  
                                
                                   let newactivity_id=object[0].id;
                                   checkActivityquerynewcount.equalTo('activity', "Activity$"+newactivity_id);        
                                  checkActivityquerynewcount.find().then((objectdata) => {
                                  if (objectdata) {
                                      
                                         if(objectdata.length)
                                         {
                                          let likecount=objectdata.length?objectdata.length:0;
                                          var queryActivitydata = new Parse.Query('Activity');  
                                            queryActivitydata.equalTo('objectId', newactivity_id);
                                           
                                            queryActivitydata.find().then(function(activityUpdate){
                                                    if(activityUpdate)
                                                    {
                                                        let activity_ob=activityUpdate[0];
                                                         activity_ob.set("likeCount", likecount);
                                                         activity_ob.save();
                                                      }
                                                    })

                                         }
                                  }
                                })


                                 //like count check


                              }
                              })



                           //new
                         }
                        }
                    }
                  })



//like
setTimeout(() => {
  currentUser.destroy()
    .then(() => {
      console.log('User account deleted successfully');
     
       commonLogoutFunction();
    })
    .catch(error => {
      console.error('Error while deleting user account:', error);
    });
        
  }, 5000);

          }

  }
  selectSection = function(e){
    // $('#navbarinner .loggedin_nav').attr("style", "display: block");
    //$('#navbarinner .signup_nav').attr("style", "display: none");
  }

  searchSuggestion= (event) => {
    this.setState({ searchloading: true }, () => {
         this.getSuggestedUserId();
         this.fetchSearchData();
      });
    /*this.state.filterSearchTitle1=searchtext;
       this.state.filterSearchTitle='';
       this.setState({ searchloading: true }, () => {
        this.fetchSearchData();
        });*/
    $("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn .search_inpt_inner").siblings(".search_rstl_mn").addClass("active");
    $("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn button.close-btn").removeClass("hide");
  };

  searchSuggestionCloase() {

    this.setState({ filterSearchTitle: '' }, () => {
      this.setState({ searchloading: true }, () => {
         this.fetchSearchData();
      });
    });
    $("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn .search_inpt_inner").siblings(".search_rstl_mn").removeClass("active");
    $("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn button.close-btn").addClass("hide");
  }

  accountRemove() {
    $(".sugested_acunt ul li a.cls-btn").closest("li").hide(200);
  }

  topAccounts() {
    $("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn>.search_rstl_mn>.inner aside.search_recent_box").hide("slow");
    $("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn>.search_rstl_mn>.inner aside.all-acunts").show("slow");
  }

  backAccounts() {
    $("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn>.search_rstl_mn>.inner aside.search_recent_box").show("slow");
    $("header.header-mn .navbar .inner .menu-search-wrap .search_wrap .form-mn>.search_rstl_mn>.inner aside.all-acunts").hide("slow");
  }
   searchHistory(e) {
      e.preventDefault();
      //console.log('userid');
}
saveSearchHistory = async (SearchTitle) => {
    //const SearchHistory = Parse.Object.extend('SearchHistory');
    //const searchHistory = new SearchHistory();
   // console.log('saveSearchHistory'+SearchTitle);

    }
  handleSearch = async (SearchTitle) => {
    console.log('handleSearch');
    //const fetchedResults = await this.performSearch(term);
   // this.setState({ results: fetchedResults });
    //await this.saveSearchHistory(SearchTitle);
  };
 handleSubmit = (e) => { 
    e.preventDefault();

    //self.handleSearch(this.state.filterSearchTitle);
    //console.log(this.state.filterSearchTitle);
    //window.location.href = "/search?q="+this.state.filterSearchTitle;
    const currentUser = Parse.User.current();
        if(currentUser) {
            const currentUser_id = currentUser.id;  
            var Searchhistory = Parse.Object.extend("Searchhistory");
            var searchhistory = new Searchhistory();
            searchhistory.set('objectid', '');
            searchhistory.set('displayUsername', this.state.filterSearchTitle);   
            searchhistory.set('displayName', this.state.filterSearchTitle);
            searchhistory.set('profilePictureSmall', '');   
            searchhistory.set('customtext', this.state.filterSearchTitle);           
            searchhistory.set('type', 'search'); 
            searchhistory.set('user', currentUser);
            searchhistory.save().then((savedhistory) => {
              // window.location.href = "/user/"+displayUsernames;
              window.location.href = "/search?q="+this.state.filterSearchTitle;
                 
            }).catch((error) => {
            });
        }
  };



  render() {
    var fetchUsername = this.state.getUsername;
    var fetchEmail = this.state.getUseremail;
    var searchusers= this.state.searchusers;
    var filterSearchTitle= this.state.filterSearchTitle;
    var searchSuggestedPhoto= this.state.searchSuggestedPhoto;
    var filterSearchTitle1= this.state.filterSearchTitle1;
    var searchHistoryData= this.state.searchHistoryData;
    var filterSearchTitleCommon='';
    var searchloading1= this.state.searchloading1;
    var searchloading= this.state.searchloading;
    
    if(filterSearchTitle)
    {
       filterSearchTitleCommon=filterSearchTitle;
    }
    if(filterSearchTitle1!=='' && filterSearchTitle==='')
    {
       filterSearchTitleCommon=filterSearchTitle1;
    }
    const togglePopup1 = (postid) => {
      this.setState(prevState => ({
        isPopupOpen1: !prevState.isPopupOpen1,
      }));
      this.setState({ post_common_id1: postid });
      $("body").addClass("modelopenexplore");
    };
  const streamid= (postid) =>{
           localStorage.setItem('storestreampagepath', 'search'); 
           localStorage.setItem('storestreamid', postid);
           localStorage.setItem('storestreamtabValue', filterSearchTitle);
           window.location.href = "/stream";
        }
const searchAccountRemoveData = (searchid) => {  
    var checkSearchquery = new Parse.Query('Searchhistory');  
    checkSearchquery.equalTo('objectId', searchid);
    checkSearchquery.find().then((object) => {
        if (object) {
            for (const objects of object) {
                  objects.destroy();             
            }
        }
      })
      .then((deletedObject) => {
        this.getSearchHistory();
      })
      .catch((error) => {
        //console.error('Error deleting record:', error);
      }); 
}
const handleClickUserHistory = (userid,displayUsername,userimage,searchtext,displayName) => {     
    let displayUsernames=displayUsername?displayUsername:'';
    const currentUser = Parse.User.current();
        if (currentUser) {
            const currentUser_id = currentUser.id;  
            var Searchhistory = Parse.Object.extend("Searchhistory");
            var searchhistory = new Searchhistory();
            searchhistory.set('objectid', userid);
            searchhistory.set('displayUsername', displayUsernames);   
            searchhistory.set('displayName', displayName);
            searchhistory.set('profilePictureSmall', userimage);   
            searchhistory.set('customtext', searchtext);           
            searchhistory.set('type', 'user'); 
            searchhistory.set('user', currentUser);
            searchhistory.save().then((savedhistory) => {
               window.location.href = "/user/"+displayUsernames;
                 
            }).catch((error) => {
            });
        }
} 


 //const { isPopupOpenCommon, loading_common, error_common,post_common_id,postDetails_common} = this.state;
var isPopupOpen1= this.state.isPopupOpen1;
    var postcommonid= this.state.post_common_id1;
    
    return (
      <React.Fragment>

        <header className="header-mn">
        <CommonPopup   isOpen={isPopupOpen1} onClose={(e) => {togglePopup1(postcommonid);} } postcommonid={postcommonid} /> 
          <nav id="navbarnew" className="navbar">
            <div className="container">
              <div className="inner d-flex flex-row flex-wrap align-items-md-center align-items-center justify-content-lg-between ">
                <div className="logo">
                  <a id="logo" rel="home" href="/">
                    <img src="/images/logo.png" alt="Joel's Kitchen" className='dt_logo'/>
                    <img src="/images/Joel_mb_logo.png" alt="Joel's Kitchen" className='mb_logo'/>
                  </a>
                </div>
                <div className='menu-search-wrap menu-search-mn d-flex flex-row flex-wrap align-items-md-center'>
                  <div className="search_wrap">
                    <form className="form-mn d-flex flex-row flex-wrap"  onSubmit={this.handleSubmit}>
                      <div className='search_inpt_inner'>
                       {/* <input className="form-control" type="search" onClick={this.searchSuggestion} placeholder="Search" aria-label="Search"/>*/}
                      <input id="search_txt_box"  autoComplete="off" className="form-control" type="search" onClick={this.searchSuggestion} placeholder="Search" aria-label="Search"  value={filterSearchTitleCommon} onChange={this.handleSearchFilterChange} />
                      
                        <button type="submit"><img src="/images/search.svg" alt="Search"  onClick={this.searchClear} /></button>
                       {/* <button type="button" className='close-btn hide' onClick={this.searchSuggestionCloase} ><img src="/images/srch-close.svg" alt="Close"/></button>*/}
                       <button type="button" className='close-btn hide'  onClick={this.searchClear}  ><img src="/images/srch-close.svg" alt="Close"/></button>
                      </div>
                      <div className='search_rstl_mn'>
{/*search*/}

{filterSearchTitleCommon? 
                        <div className='inner'>
                          <aside className="search_box sugested_acunt all-acunts" style={{"display": "none"}}>
                            <div className='tlt-part d-flex flex-row flex-wrap align-items-center justify-content-between '>
                              <a href="#" title='All Accounts' onClick={this.backAccounts}><img src="/images/back_top.svg" alt="Back to Top" /></a>
                              <h2>All accounts</h2>
                            </div>
                            <div className='cnt-part'>
                              <ul className="list_grp">
                              
                                 {searchloading && searchusers.map(function (user, i) {

                                let userimage='';
                               if(user.get("profilePictureSmall") && user.get("profilePictureSmall").url()!==undefined)
                               {
                                   userimage=user.get("profilePictureSmall").url();
                               }
                               else{
                                   userimage="/images/default_userpic0.png";
                               }  
                              
                          {
                            {/*href={user.get("displayUsername")?"/user/"+user.get("displayUsername"):''}*/}
                            return (
                               <li className="menu"  key={i+100}>
                                  <a href="javascript:void(0);" title={user.get("displayUsername")?user.get("displayUsername"):''} className="media"   onClick={(e) => {handleClickUserHistory(user.id,user.get("displayUsername"),userimage,filterSearchTitleCommon,user.get("displayName"));}}  >
                                    <div className="media-left"><img src={userimage} width="40px" height="40px" alt={user.get("displayUsername")?user.get("displayUsername"):''} /></div>
                                    <div className="media-body">
                                     {user.get("displayName")? <h6 className="mt-0">{user.get("displayName")}</h6>:''}
                                      <span>{user.get("displayUsername")?user.get("displayUsername"):''}</span>
                                    </div>
                                  </a>
                                </li>
                            );
                          }
                        })}
                              </ul>
                            </div>
                          </aside>
                          <aside className="search_box recent_box recent_search sugested_acunt" style={{"display": "none"}}>
                            <h2>Recent</h2>
                            <ul className="list_grp">
                              <li className="menu">
                                <a className='cls-btn' onClick={this.accountRemove}><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M1.90372 10.2268L0.903723 9.27106L4.90372 5.44818L0.903718 1.6253L1.90372 0.669587L5.90372 4.49246L9.90372 0.669592L10.9037 1.62531L6.90372 5.44818L10.9037 9.27106L9.90372 10.2268L5.90372 6.4039L1.90372 10.2268Z" fill="#1C1B1F"/></svg></a>
                                <a href="/user/orchidsnsweettea" title="orchidsnsweettea" className="media">
                                  <div className="media-left"><img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/be32f00c681ba0887e6220be0e301b28_file.bin" width="40px" height="40px" alt="itsallgoodvegan" /></div>
                                  <div className="media-body">
                                    <h6 className="mt-0">orchidsnsweettea</h6>
                                    <span>Orchids + Sweet Tea</span>
                                  </div>
                                </a>
                              </li>
                              <li className="menu">
                              <a className='cls-btn'><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M1.90372 10.2268L0.903723 9.27106L4.90372 5.44818L0.903718 1.6253L1.90372 0.669587L5.90372 4.49246L9.90372 0.669592L10.9037 1.62531L6.90372 5.44818L10.9037 9.27106L9.90372 10.2268L5.90372 6.4039L1.90372 10.2268Z" fill="#1C1B1F"/></svg></a>
                                <a href="/user/itsallgoodvegan" title="itsallgoodvegan" className="media">
                                  <div className="media-left"><img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/012f10ac9cba7b5211b1229b9e453b2b_file.bin" width="40px" height="40px" alt="itsallgoodvegan" /></div>
                                  <div className="media-body">
                                    <h6 className="mt-0">itsallgoodvegan</h6>
                                    <span>Marissa Wong</span>
                                  </div>
                                </a>
                              </li>
                              <li className="menu">
                              <a className='cls-btn'><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M1.90372 10.2268L0.903723 9.27106L4.90372 5.44818L0.903718 1.6253L1.90372 0.669587L5.90372 4.49246L9.90372 0.669592L10.9037 1.62531L6.90372 5.44818L10.9037 9.27106L9.90372 10.2268L5.90372 6.4039L1.90372 10.2268Z" fill="#1C1B1F"/></svg></a>
                                <a href="/user/cheerfulchoices" title="cheerfulchoices" className="media">
                                  <div className="media-left"><img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6c7c3c80ecd4eac86050b504aa6bc8bb_file.bin" width="40px" height="40px" alt="itsallgoodvegan" /></div>
                                  <div className="media-body">
                                    <h6 className="mt-0">cheerfulchoices</h6>
                                    <span>Mackenzie Burgess</span>
                                  </div>
                                </a>
                              </li>

                            </ul>
                          </aside>
                          <aside className="search_box recent_box recomnd_you img_post_grid" style={{"display": "none"}}>
                            <h2>Recommended for you </h2>
                            <ul className="list_grp">

                            
                          
                               {searchSuggestedPhoto.map(function (photo, i) {

                               let photoimage='';
                               if(photo.get("image") && photo.get("image").url()!==undefined)
                               {
                                   photoimage=photo.get("image").url();
                               }
                               else{
                                   photoimage="/images/default_userpic0.png";
                               } 

                                  {
                            return (
                              <li  key={i+100}>
                                 {/* <a href={photo.id?"/post/"+photo.id:''} > */}
                                 <a href='javascript:void(0);' onClick={(e) => {togglePopup1(photo.id);}}  >
                                   <figure className="thumbnail">
                                     {/* <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                   */}
                                   <img src={photoimage} />
                                   
                                    </figure>
                                  </a>
                                </li>
                            );
                          }


                              })}
                            </ul>
                          </aside>
                          <aside className="search_box search_recent_box top_account sugested_acunt">
                            <div className='tlt-part d-flex flex-row flex-wrap align-items-center justify-content-between '>
                              <h2>Top accounts</h2>
                              {searchloading &&  searchusers && searchusers.length>4?
                              <a href="#" title='See more' className='see-link' onClick={this.topAccounts}>See more...</a>:""}
                            </div>
                            <div className='cnt-part'>
                              <ul className="list_grp">


                              {searchloading && searchusers.map(function (user, i) {
                              if(i<3)
                              {
                                let userimage='';
                               if(user.get("profilePictureSmall") && user.get("profilePictureSmall").url()!==undefined)
                               {
                                   userimage=user.get("profilePictureSmall").url();
                               }
                               else{
                                   userimage="/images/default_userpic0.png";
                               }  
                              
                          {
                            return (
                               <li className="menu"  key={i+100}>
                                  <a href="javascript:void(0);"  className="media"   onClick={(e) => {handleClickUserHistory(user.id,user.get("displayUsername"),userimage,filterSearchTitleCommon,user.get("displayName"));}} >
                                    <div className="media-left"><img src={userimage} width="40px" height="40px" alt={user.get("displayUsername")?user.get("displayUsername"):''} /></div>
                                    <div className="media-body">
                                      {user.get("displayName")?<h6 className="mt-0">{user.get("displayName")}</h6>:''}
                                      <span>{user.get("displayUsername")?user.get("displayUsername"):''}</span>
                                    </div>
                                  </a>
                                </li>
                            );
                          }
                         }

                        })}
                              
                              </ul>
                            </div>
                          </aside>
                          <aside className="search_box search_recent_box top_post img_post_grid">
                            <div className='tlt-part d-flex flex-row flex-wrap align-items-center justify-content-between '>
                              <h2>Top posts </h2>
                              {searchloading1 && searchSuggestedPhoto && searchSuggestedPhoto.length>4?<a href={filterSearchTitle?'/search?q='+filterSearchTitle:''} title='See more' className='see-link'>See more...</a>:""}
                            </div>
                            <div className='cnt-part'>
                              <ul className="list_grp">
                                {searchSuggestedPhoto.map(function (photo, i) {
                               if(i<4)
                              {
                               let photoimage='';
                               if(photo.get("image") && photo.get("image").url()!==undefined)
                               {
                                   photoimage=photo.get("image").url();
                               }
                               else{
                                   photoimage="/images/default_userpic0.png";
                               } 
{/*href='javascript:void(0);' onClick={(e) => {togglePopup1(photo.id);}}*/}
                                  {
                            return (
                              <li  key={i+100}>
                                 {/*   <a href={photo.id?"/post/"+photo.id:''} title={photo.get("caption")?photo.get("caption"):''} > */}
                                   <a  href='javascript:void(0);' id={photo.id} onClick={(e) => {streamid(photo.id);}}  >
                                   <figure className="thumbnail">
                                     {/* <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                   */}
                                   <img src={photoimage} />
                                   
                                    </figure>
                                  </a>
                                </li>
                            );
                          }
                           }

                              })}

                         


                             
                              </ul>
                            </div>
                          </aside>
                        </div>
                        : 
                      
                        <div className='inner'>

                          <aside className="search_box sugested_acunt all-acunts" style={{"display": "none"}}>
                            <div className='tlt-part d-flex flex-row flex-wrap align-items-center justify-content-between '>
                              <a href="#" title='All Accounts' onClick={this.backAccounts}><img src="/images/back_top.svg" alt="Back to Top" /></a>
                              <h2>All accounts</h2>
                            </div>
                            <div className='cnt-part'>
                              <ul className="list_grp">


                           
                              </ul>
                            </div>
                          </aside>
                        
                          <aside className="search_box recent_box recomnd_you img_post_grid" style={{"display": "none"}}>
                            <h2>Recommended for you </h2>
                            <ul className="list_grp">
                           

                             
                            </ul>
                          </aside>
                          <aside className="search_box search_recent_box top_account sugested_acunt">
                          {/*searchHistoryData.length>0 && <div>*/}
                            <div className='tlt-part d-flex flex-row flex-wrap align-items-center justify-content-between '>
                              <h2>Recent</h2>
                             {/* <a href="#" title='See more' className='see-link' onClick={this.topAccounts}>See more...</a> */}
                            </div>
                            <div className='cnt-part'>
                              <ul className="list_grp">

                              {searchHistoryData.map(function (user, i) {
                              if(i<3)
                              {
                                let userimage='';
                               if(user.get("profilePictureSmall") && user.get("profilePictureSmall")!==undefined)
                               {
                                   userimage=user.get("profilePictureSmall");
                               }
                               else{
                                   userimage="/images/default_userpic0.png";
                               }  
                              
                          {
                            return (
                             <li className="menu"  key={i+100}>
                                <a className='cls-btn'  onClick={(e) => {searchAccountRemoveData(user.id);}}   ><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M1.90372 10.2268L0.903723 9.27106L4.90372 5.44818L0.903718 1.6253L1.90372 0.669587L5.90372 4.49246L9.90372 0.669592L10.9037 1.62531L6.90372 5.44818L10.9037 9.27106L9.90372 10.2268L5.90372 6.4039L1.90372 10.2268Z" fill="#1C1B1F"/></svg></a>
                                <a href="javascript:void(0);"  className="media"   onClick={(e) => {handleClickUserHistory(user.id,user.get("displayUsername"),userimage,filterSearchTitleCommon,user.get("displayName"));}}  title={user.get("displayUsername")?user.get("displayUsername"):''} className="media">
                                  <div className="media-left"><img  src={userimage}  width="40px" height="40px" alt={user.get("displayUsername")?user.get("displayUsername"):''} /></div>
                                  <div className="media-body">
                                  {user.get("displayName")?  <h6 className="mt-0">{user.get("displayName")}</h6>:''}
                                    <span>{user.get("displayUsername")?user.get("displayUsername"):''}</span>
                                  </div>
                                </a>
                              </li>
                            );
                          }
                         }

                        })}
                             

                              
                              </ul>
                            </div>
                          {/*</div>}*/}
                          </aside>
                          <aside className="search_box search_recent_box top_post img_post_grid">
                            <div className='tlt-part d-flex flex-row flex-wrap align-items-center justify-content-between '>
                              <h2>Recommended for you </h2>
                            </div>
                            <div className='cnt-part'>
                              <ul className="list_grp">

                              {/*href='javascript:void(0);' onClick={(e) => {togglePopup1(photo.id);}} */}

                                 {searchSuggestedPhoto.map(function (photo, i) {
                              if(i<4)
                              {
                               let photoimage='';
                               if(photo.get("image") && photo.get("image").url()!==undefined)
                               {
                                   photoimage=photo.get("image").url();
                               }
                               else{
                                   photoimage="/images/default_userpic0.png";
                               } 

                                  {
                            return (
                              <li  key={i+100}>
                                 {/* <a href={photo.id?"/post/"+photo.id:''}  >  */}
                                 <a  href='javascript:void(0);' onClick={(e) => {streamid(photo.id);}}  >
                                   <figure className="thumbnail">
                                   
                                   <img src={photoimage} />
                                   
                                    </figure>
                                  </a>
                                </li>
                            );
                          }
                             }

                              })}



                              </ul>
                            </div>
                          </aside>
                        </div> }
                     


                      {/*search*/}
                      </div>
                    </form>
                  </div>
                </div>
                <div className='menu-search-wrap menu-search-social d-flex flex-row flex-wrap align-items-md-center'>
                  <div className="menu_nav d-flex flex-row flex-wrap">                      
                    {(fetchUsername!="" && fetchUsername !=null)?
                      <div className="signup_nav user_prfl_nav btn-group">
                        <div className='signup_nav_grp'>
                          <button type="button" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {this.state.userImage!==null?
                              <img height="150" width="150" className="userProfileImageLarge"  src={this.state.userImage}  alt={fetchUsername} />
                              :<img height="150" width="150"  src="/images/default_userpic0.png" alt="Profile Picture" />
                            }
                          </button>
                          <div className="dropdown-menu dropdown-menu-right">
                           {/* <a href="/my-profile" className="dropdown-item" type="button">Profile</a>
                            <button className="dropdown-item" type="button">Business Suite</button>
                            <button className="dropdown-item" type="button">Insights</button>
                            <button className="dropdown-item" type="button">Notifications</button>
                            <button className="dropdown-item" type="button">Settings</button>
                            <button className="dropdown-item" type="button">Dark Mode</button>*/}
                            <button className="dropdown-item" onClick={this.handleDeleteAccount} type="button">Delete Account</button>
                            <button className="dropdown-item" onClick={this.handleLogoutfunc} type="button">Log Out</button>
                          
                             <button style={{display:"none"}} href='javascript:void(0);'  type="button" className='btn' data-toggle="modal" data-target="#deleteaccount"  id="deleteaccountid">get </button>
                               <button style={{display:"none"}} href='javascript:void(0);'  type="button" className='btn' data-toggle="modal" data-target="#deleteaccountMsg"  id="deleteaccountidMsg">get </button>
                           {/* <button className="dropdown-item" type="button">Cancel</button>*/}
                          </div>
                        </div>
                      </div> : 
                      <div className="signup_nav cta_btn d-flex flex-row flex-wrap">
                        <div className='secondary-btn btn-wrp'>
                          <button type="button" className='btn' data-toggle="modal" data-target="#loginModal"  id="login_popup_btn">Log in </button>
                          <button style={{display:"none"}} href='javascript:void(0);'  type="button" className='btn' data-toggle="modal" data-target="#kitchenQrModal"  id="kitchenQrModal_btn">get </button>
                        </div>
                        <div className='primary-btn btn-wrp'>
                          <button type="button" className="btn" data-toggle="modal" data-target="#registrationModal"  id="register_popup_btn">Sign up </button>
                        </div>
                      </div>
                    }
                    <button id='handlemenu'  style={{display:"none"}}   className='btn btn-primary' onClick={this.selectSection}>menu</button>
                  </div>
                </div>
              </div>
            </div>
          </nav> 
          <input type="hidden" name="current_weburl" id="current_weburl" value={window.location.pathname} />
        </header> 
        {/*single post overlay  common popup*/}
     {/*   <div   style={{ position: "absolute",right: "0",'z-index': "99999" }}>
         
</div > */}

       {/* <a href="javascript:;"  onClick={this.openPopupCommon('h8O7iRKvgG')}  id="large_challenge_image_btn_common" type="button" > popup</a>

          <a href="javascript:;"  style={{ display: "none" }}  data-toggle="modal" data-target="#large_challenge_image_common"   id="large_challenge_image_common_btn" type="button" >modal</a>
*/}
         

    {/*<button onClick={this.createEntry}> + </button>
        {this.showPopup ? <div><Popup  postData='Iz4dAaH6i0' handleSubmit={this.handleSubmitPopup} /></div> : null}
        </div>
       <button id='closepopupsingle' className="closepopupsingle"  onClick={this.cancelClosepopupText} >Cancel</button>*/}
        {/*single post overlay  common popup*/}

      {/*  postDetails && isPopupOpenCommon && postDetailscomment &&  */}

         {/*isPopupOpenCommon && loading_common ? (
                    <p></p>
                  ) : error_common ? (
                    <p></p>
                  ) : (
                isPopupOpenCommon && postDetails_common &&  this.renderDetailPageCommon(post_common_id)
                  )*/}

     <div className="modal fade post_modal post_modal_overlay createPostCloseModal" id="deleteaccount" tabIndex="-1" role="dialog" data-backdrop="true" data-keyboard="true" aria-labelledby="createPostCloseTitle" aria-hidden="true">
          <div className='bg_overlay'></div>
          <div className="modal-dialog modal-md modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className='inner text-center'>
                  <div className='title-main'>
                    <h6>Are you sure you want to delete account?</h6>
                   
                  </div>
                  <div className='action-part'>
                    <a href='javascript:void(0);' className='btn danger btn-post-discard' data-dismiss="modal" aria-label="Close" title='Yes'  onClick={this.deleteUserAccount}>Yes</a>
                    <a href='javascript:void(0);' className='btn cancel  btn-post-cancel'  onClick={this.checkCancel} data-dismiss="modal" aria-label="Close" title='No'>No</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade post_modal post_modal_overlay createPostCloseModal" id="deleteaccountMsg" tabIndex="-1" role="dialog" data-backdrop="true" data-keyboard="true" aria-labelledby="createPostCloseTitle" aria-hidden="true">
          <div className='bg_overlay'></div>
          <div className="modal-dialog modal-md modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className='inner text-center'>
                  <div className='title-main'>
                    <h6>Account Deleted</h6>
                   
                  </div>
                  <div className='action-part'>
                   {/* <a href='javascript:void(0);' className='btn danger btn-post-discard' data-dismiss="modal" aria-label="Close" title='Yes'  onClick={this.deleteUserAccount}>Yes</a>
                    <a href='javascript:void(0);' className='btn cancel  btn-post-cancel'  onClick={this.checkCancel} data-dismiss="modal" aria-label="Close" title='No'>No</a>*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </React.Fragment>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js